import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { fetchVisualization, fetchVisualizationAsync, setVisualizationState } from '../../actions/app/visualization.actions'
import { getVisualizationApiUrl } from '../../../constants/apiUrls'
import isAveStringFramePostMessageHackEnabledSelector from '../../selectors/feature-scope/isAveStringFramePostMessageHackEnabledSelector'
import { ApiRequest } from '../../apiRequest'
import { showE3DSharingDashboard, setShouldAutoDisplayE3DSharingDashboard } from '../../actions/app/e3dSharingDashboard.actions'
import { logger } from '../../../utils/dccLogger'
import { createLatestRequestTracker } from './helpers/latestRequestTracker'

declare global {
    interface Window {
        aveCarConfiguration: string
    }
}

// eslint-disable-next-line max-len
const visualizationMiddleware = (window: Window, apiRequest: ApiRequest): Middleware => (store) => {
    const latestRequest = createLatestRequestTracker()

    return (next) => (action) => {
        next(action)
        const { dispatch, getState } = store

        if (isActionOf(fetchVisualization, action)) {
            latestRequest.markIssued(action)
            apiRequest({
                options: {
                    url: getVisualizationApiUrl(),
                    method: 'GET',
                },
                asyncActions: fetchVisualizationAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(fetchVisualizationAsync.success, action)) {
            if (!latestRequest.isLatest(action)) {
                logger.info('Ignoring visualization response of a superseded request')
                return
            }
            const visualization = action.payload

            dispatch(setVisualizationState(visualization))

            if (isAveStringFramePostMessageHackEnabledSelector(getState())) {
                if (window.parent !== window) {
                    window.parent.postMessage({
                        key: 'prCode',
                        prCode: visualization.aveString,
                    }, '*')
                }

                // eslint-disable-next-line no-param-reassign
                window.aveCarConfiguration = visualization.aveString
            }

            const dashboardState = getState().e3dSharingDashboard
            if (dashboardState.shouldAutoDisplay && visualization.aveString) {
                logger.info('Auto-displaying E3D Sharing Dashboard now that aveString is available')
                dispatch(showE3DSharingDashboard())
                dispatch(setShouldAutoDisplayE3DSharingDashboard(false))
            }
        }
    }
}

export default visualizationMiddleware
